var render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",style:({position: 'relative', width: 'min-content', width: 'min-content'})},[_c('v-icon',_vm._b({style:({
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) scale(0.95)'
    }),attrs:{"color":_vm.server.textColor || 'white'}},'v-icon',( _obj = {}, _obj[_vm.sizeProp] = _vm.sizeProp === 'size' ? _vm.size : true, _obj ),false),[_vm._v(" mdi-checkbox-blank ")]),_c('v-icon',_vm._b({style:({
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    })},'v-icon',( _obj$1 = {}, _obj$1[_vm.sizeProp] = _vm.sizeProp === 'size' ? _vm.size : _vm.sizeProp === 'size' ? _vm.size : true, _obj$1.color = (_vm.server || {}).color || 'grey', _obj$1 ),false),[_vm._v(" "+_vm._s(("mdi-alpha-" + (((_vm.server || {}).name || 's').toLowerCase()[0]) + "-box"))+" ")]),_c('v-icon',_vm._b({attrs:{"color":"transparent"}},'v-icon',( _obj$2 = {}, _obj$2[_vm.sizeProp] = _vm.sizeProp === 'size' ? _vm.size : true, _obj$2 ),false),[_vm._v(" mdi-checkbox-blank ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }